export function excludeAddressComponentsWithType(
  type: string,
): (component: google.maps.GeocoderAddressComponent) => boolean {
  return (component) => !component.types.includes(type);
}
